import { editedEffect } from 'state/actions';
import { getEffectById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { Command, CommandFunction } from './Command';

function setEffectValue(
  effectId: string,
  propertyName: string,
  value: any
): CommandFunction {
  return (dispatch: Function, getState: () => RootState) => {
    const { flyer } = getState();
    const effect = getEffectById(flyer, effectId);
    if (effect !== undefined) {
      effect.setProperty(propertyName, value);
      dispatch(editedEffect(effect));
    }
  };
}

export class EditEffectCommand extends Command {
  effectId: string;
  propertyName: string;
  initialValue: any;
  finalValue: any;
  constructor(
    effectId: string,
    propertyName: string,
    initialValue: any,
    finalValue: any
  ) {
    super();
    this.effectId = effectId;
    this.propertyName = propertyName;
    this.initialValue = initialValue;
    this.finalValue = finalValue;
    this.canMerge = true;
  }
  execute(): CommandFunction {
    return setEffectValue(this.effectId, this.propertyName, this.finalValue);
  }

  undo(): CommandFunction {
    return setEffectValue(this.effectId, this.propertyName, this.initialValue);
  }

  merge(nextCommand: Command): void {
    if (nextCommand instanceof EditEffectCommand) {
      this.finalValue = nextCommand.finalValue;
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/EditEffectCommand.ts